import React from 'react';
import { Paper,ListSubheader } from '@mui/material';
import { useTemperatureGraphDetails } from '../../data/DataProviders/TemperatureGraphDataProvider';
import { isDataLoaded } from '../../types/data-providers';
import { DataIndicators } from '../DataIndicators';
import { LineGraph } from '../LineGraph/LineGraph';
import { TemperatureGraphParameter } from '../../constants/lineGraphParameter';
import { Icon } from '../../lib/icons';
import chartLabelNameStyle from '../../app/insulgard/ChartLabelNameStyle';
export const TemperatureGraph: React.FC = () => {
    const classes = chartLabelNameStyle();
    const responseTemperatureData = useTemperatureGraphDetails();
    const isEmpty = isDataLoaded(responseTemperatureData)
        ? responseTemperatureData.value.chartData.length === 0
        : false;
    const minValueData: object[] = [];
    const maxValueData: object[] = [];
    const startDate: string = (isDataLoaded(responseTemperatureData) && responseTemperatureData.value.startDate) || '';
    const endDate: string = (isDataLoaded(responseTemperatureData) && responseTemperatureData.value.endDate) || '';
    const tickInterval = 336 * 3600 * 1000;
    if (isDataLoaded(responseTemperatureData)) {
        responseTemperatureData.value.chartData.filter((data: any) => {
            if (new Date(data.dateTime) >= new Date(startDate) || new Date(data.dateTime) <= new Date(endDate)) {
                const maxValue: any = parseFloat(data.maxTemp);
                const minValue: any = parseFloat(data.minTemp);
                const fulldate = new Date(data.dateTime).getTime();
                minValueData.push([fulldate, minValue]);
                maxValueData.push([fulldate, maxValue]);
            }
            return true;
        });
    }
    let chartLabelName;
    TemperatureGraphParameter.map((temp: any) => {
        chartLabelName = temp.chartLabelName;
    });
    return (
        <div data-testid="device-info-temperature" style={{ border: '1px solid #dfe1e1', borderRadius: '5px' }}>
            <Paper elevation={0} style={{ border: '0px' }}>
                <DataIndicators
                    errorMessage="Record not found"
                    emptyMessage="Record not found"
                    data={responseTemperatureData}
                    emptyIcon="BarChart"
                    isEmpty={isEmpty}
                    isDetailedInfo={false}
                />
            </Paper>

            {isDataLoaded(responseTemperatureData) && (
                <>
                    {responseTemperatureData.value.chartData.length > 0 && (
                        <Paper elevation={0} variant="outlined">   
                          <div className={classes.titleBoxContent}>
                                <ListSubheader color="primary" component="div" style={{ fontWeight: 600 }}>
                                   {chartLabelName}
                                    <span className={classes.icon}>
                                        {<Icon.Info className={classes.infoicon}/>}
                                    </span>
                                </ListSubheader>                               
                            </div>                    
                           <LineGraph startDate={startDate} endDate = {endDate}
                            maxValueData = {maxValueData} minValueData = {minValueData} tickInterval = {tickInterval} highChartGraphParameter = {TemperatureGraphParameter}/> 
                        </Paper>
                    )}
                </>
            )}
        </div>
    );
};
